import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Space } from 'antd';

import { NoPermission } from '~/components';
import { usePermissions } from '~/hooks';
import { PageHeader } from '~/layout';
import { selectProfiles } from '~/slices/ui';
import Amounts from './Amounts';
import Transactions from './Transactions';
import ColumnChart from './ColumnChart';
import TopCountriesChart from './TopCountriesChart';
import theme from '~/theme';
import features from '~/featuresWithDefaults';
import { accounts } from '~/routes';
import { ArrowRedoIcon } from '~/img';

const Home: FC<RouteComponentProps> = () => {
  const [t] = useTranslation();
  const { roles } = usePermissions();
  const { data } = useSelector(selectProfiles);

  let isPermissionDenied = true;
  roles?.forEach((role) => {
    if (role !== 'BUSINESS_CASHIER' && role !== 'BUSINESS_SALES_AGENT') {
      isPermissionDenied = false;
    }
  });
  const hasAmountsPermissions = usePermissions('business.accounts.view');

  return isPermissionDenied ? (
    <NoPermission />
  ) : (
    <>
      <PageHeader
        heading={hasAmountsPermissions ? t('overview') : t('dashboard')}
        showSearch={false}
        actions={
          hasAmountsPermissions ? (
            <Link to={`/${accounts}`}>
              <Button icon={<ArrowRedoIcon />} type="primary">
                {t('View all accounts')}
              </Button>
            </Link>
          ) : undefined
        }
      />
      {data && (
        <Space size={32} direction="vertical" style={spaceStyle}>
          {hasAmountsPermissions && <Amounts />}
          {hasAmountsPermissions && features.niDemo && <ColumnChart />}
          <Transactions />
          <Row gutter={[16, 0]} wrap={false}>
            {features.niDemo && (
              <Col flex="500px">
                <TopCountriesChart />
              </Col>
            )}
            {features.niDemo && (
              <Col flex="465px">
                <img src={require('~/img/advBanner.png')} alt="" style={imageStyle} />
              </Col>
            )}
          </Row>
        </Space>
      )}
    </>
  );
};

const imageStyle = {
  borderRadius: theme.borderRadiusBase,
  boxShadow: '0 2px 6px rgb(0 0 0 / 4%)',
};
const spaceStyle = { width: '100%', marginBottom: 24, marginTop: -8 };

export default Home;
